import { AttachmentViewerDocument, AttachmentViewerExecutionModel } from "@rightship-tech/common-ui/models/attachments.models";
import { autoinject, PLATFORM, useView } from "aurelia-framework";

@autoinject
@useView(PLATFORM.moduleName("@rightship-tech/rs-inspections-ui/views/drawer/tabs/all-attachments/all-attachments.html"))
export class AllAttachments {
    public getAttachmentDocuments: () => Promise<AttachmentViewerDocument[]>
    public newTabIdentifier: string;
    public selectedThumbnailId: string;

    constructor() {
    }

    activate(model: AttachmentViewerExecutionModel) {
        this.getAttachmentDocuments = model.getAttachmentDocuments;
        this.newTabIdentifier = model.newTabIdentifier;
        this.selectedThumbnailId = model.selectedThumbnailId;
    }
}
